import { Backdrop } from '../ui/backdrop';
import { PrimaryBackground } from '../../app/theme/tokens/colors';
import { useResponsive } from '../../hooks/useResponsive';

export const SimplePopup = ({ width, height, outlet, zIndex }) => {
    const { isMobile, isTablet } = useResponsive();
    const isTabletOrMobile = isMobile || isTablet;
    return (
        <>
            {isTabletOrMobile ? (
                <Backdrop style={{ zIndex }}>
                    <div
                        style={{
                            padding: '5px',
                            margin: 0,
                            boxSizing: 'border-box',
                            width: '100vw',
                            backgroundColor: PrimaryBackground,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            height: '100dvh',
                            maxHeight: '100dvh',
                            borderRadius: 0,
                            WebkitOverflowScrolling: 'touch',
                        }}
                    >
                        {outlet}
                    </div>
                </Backdrop>
            ) : (
                <Backdrop style={{ zIndex }}>
                    <div
                        style={{
                            overflowX: 'hidden',
                            padding: '15px',
                            boxSizing: 'border-box',
                            width: `${width}px`,
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            height: `${height}px`,
                            backgroundColor: PrimaryBackground,
                            borderRadius: '15px',
                        }}
                    >
                        {outlet}
                    </div>
                </Backdrop>
            )}
        </>
    );
};
